<template>
    <el-dialog class="el-dialogs" :title="title" width="600px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="90px">
            <el-form-item label="分组名称" prop="groupingName">
                <el-input v-model.trim="searchForm.groupingName" maxlength="20"
                          placeholder="请输入分组名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="上级分组" prop="parentId">
                <treeSelect ref="menuParentTree"
                            style="width: 100%"
                            :props="{
                                           children: 'children',
                                           label: 'groupingName',
                                           value:'id'
                                          }"
                            :data="parentIdList"
                            :value="searchForm.parentId"
                            :clearable="true"
                            :accordion="true"
                            :filterable="true"
                            :level="level"
                            @getValue="selectCascader"
                ></treeSelect>
            </el-form-item>
            <el-form-item label="状态" prop="groupingState">
                <div class="flex_l_c">
                    <el-switch
                            v-model="searchForm.groupingState"
                            active-value="1"
                            inactive-value="0">
                    </el-switch>
                    <div style="font-size: 12px;color: #C0C0C0;padding-left: 10px">
                        启用后，还需要在【分类索引管理】中添加并公开，才能应用于资源。
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import treeSelect from "@/components/treeSelect/treeSelect.vue";

export default {
    name: "addGrouping",
    components: {treeSelect},
    data() {
        return {
            title: '',
            visible: false,
            searchForm: {
                id: '',
                groupingName: '',
                parentId: '',
                groupingState: '',
            },
            rules: {
                groupingName: [
                    {required: true, message: '请输入分组名称', trigger: 'blur'}
                ],
            },
            level:null,
            parentIdList: [],
        }
    },

    methods: {
        //typeName view新增
        init(typeName, row, level, parentIdList) {
            this.searchForm = {
                id: '',
                groupingName: '',
                parentId: '',
                groupingState: '',
            }
            this.visible = true
            this.parentIdList = parentIdList
            if (typeName == 'view') {
                this.title = '新增分组'
                this.level= level
                this.setTreeList(this.parentIdList)
            } else {
                this.title = '编辑分组'
                this.getDetail(row.id)
            }
        },
        setTreeList(datas) { // 遍历树  获取id数组
            let that = this;
            console.log("11:",datas)
            for (let i = 0; i < datas.length; i++) {
                if(that.level && datas[i].level > that.level){
                    datas.splice(i, 1); // 删除当前元素
                    i--;
                }else{
                    if (datas[i].children) {
                        that.setTreeList(datas[i].children)
                    }
                }
            }
        },
        getDetail(id) {
            this.$axios(this.api.academic.groupingGetById + id, {}).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                }
            })
        },

        //匹配文件目录
        selectCascader(val, label, node) {
            this.searchForm.parentId = val
            // this.inputForm.level = node.level
            // this.inputForm.folderName = node.folderName
        },

        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.parentId == null) {
                        this.searchForm.parentId = ''
                    }
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.groupingUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.groupingSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>
